import React from 'react';
import { Tag, Modal } from 'antd';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {
    convertFromRaw,
    convertToRaw,
    CompositeDecorator,
    getDefaultKeyBinding, KeyBindingUtil,
    Editor,
    EditorState,
    ContentBlock,
    genKey,
    ContentState,
    Entity,
    AtomicBlockUtils,
    Modifier
} from 'draft-js';
import "draft-js/dist/Draft.css";

const { hasCommandModifier } = KeyBindingUtil;

const getEditorState = function () {
    return this.state.editorState;
}
const getContentState = function () {
    const editorState = getEditorState.call(this);
    if (!editorState) return null;
    return editorState.getCurrentContent();
}
const getContentStateToRow = function () {
    const contentState = getContentState.call(this);
    if (!contentState) return null;
    return convertToRaw(contentState);
}
const getBlocks = function () {
    const contentStateToRow = getContentStateToRow.call(this) || {};
    return contentStateToRow.blocks;
}

function findEntitieByType(type, contentBlock, callback, contentState) {
    // const text = contentBlock.getText();
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === type
            );
        },
        callback,
    );
};
function span_onClick() {
    // alert("我是变量");
}
function constant_span_onClick() {
    // alert("我是常量");
}
const TokenSpan = (props) => {
    const contentState = props.contentState;
    const blocks = convertToRaw(contentState);
    const entityMap = blocks.entityMap;
    let href = "not found";
    for (const key in entityMap) {
        const entity = entityMap[key];
        if (props.decoratedText === entity.data.title) href = entity.data.href;
    }
    return (
        <span title={href} style={{ backgroundColor: '#d3adf7', padding: '2px' }} onClick={span_onClick}>
            {props.children}
        </span>
    );
};
const ConstantSpan = (props) => {
    const contentState = props.contentState;
    const blocks = convertToRaw(contentState);
    const entityMap = blocks.entityMap;
    let href = "not found";
    for (const key in entityMap) {
        const entity = entityMap[key];
        if (props.decoratedText === entity.data.title) href = entity.data.href;
    }
    return (
        <span title={href} style={{ backgroundColor: 'rgba(78,238,148, 0.9)', padding: '2px' }} onClick={constant_span_onClick}>
            {props.children}
        </span>
    );
};
const findWithRegex = (regex, contentBlock, callback) => {
    const text = contentBlock.getText();
    let matchArr;
    let start;
    while ((matchArr = regex.exec(text)) !== null) {
      start = matchArr.index;
      callback(start, start + matchArr[0].length);
    }
  };
const compositeDecorator = new CompositeDecorator([
    {
        strategy: findEntitieByType.bind(this, "variable"),
        component: TokenSpan,
    },
    // {
    //     strategy:  (contentBlock, callback, contentState) => {
    //         const emojiRegex = /#{(.*?)}/g;
    //         findWithRegex(emojiRegex, contentBlock, callback);
    //     },
    //     component: TokenSpan,
    // },
    {
        strategy: findEntitieByType.bind(this, "constant"),
        component: ConstantSpan,
    },
]);

const refreshByContentStateToRowJson = function (json) {
    if (!json) return;
    let jsonObj = (typeof json === "string") ? JSON.parse(json) : json;
    const contentState = convertFromRaw(jsonObj);
    const editorState = EditorState.createWithContent(contentState, compositeDecorator);
    this.setState({ editorState });
    return editorState;
}

const insertFun = function (type, link, title) {
    let editorState = this.state.editorState;
    let contentState = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    //创建Entity
    const contentStateWithEntity = contentState.createEntity(type, 'mutability', {
        href: link, title
    });
    //获取entityKey
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    if (title && title.length > 0) {
        //包含title，则替换选中部分
        contentState = Modifier.insertText(
            contentState,
            selection,
            `${title}`,
            // editorState.getCurrentInlineStyle(),
            styles.immutable,
            entityKey
        );
    } else {
        //给选中部分加上链接
        contentState = Modifier.applyEntity(contentState, selection, entityKey);
    }
    const newState = EditorState.push(editorState, contentState, 'insert-characters');

    this.setState({ editorState: newState, visible: false,loading:false });
}

const myKeyBindingFn = function (e) {
    if (e.keyCode === 83 /* `S` key */ && hasCommandModifier(e)) {
        return 'myeditor-save';
    }
    return getDefaultKeyBinding(e);
}

const getValue = function () {
    const contentStateToRow = getContentStateToRow.call(this) || {};
    var blocks = contentStateToRow.blocks || [];
    var result = "";
    blocks.forEach(element => {
        result = result + element.text;
    });
    return result;
};

const getHtml = function () {
    const contentStateToRow = getContentStateToRow.call(this);
    if (!contentStateToRow) return null;
    let html = draftToHtml(contentStateToRow);
    return html;
};

const getContentStateToRowForJson = function () {
    const contentStateToRow = getContentStateToRow.call(this);
    if (!contentStateToRow) return null;
    let contentStateToRowJson = JSON.stringify(contentStateToRow);
    return contentStateToRowJson;
};

// const getEntityData = function (editorState) {
//     //获取选中block
//     const block = getSelectBlock(editorState);
//     const entityKey = block.getEntityAt(0);
//     const contentState = editorState.getCurrentContent();
//     const entity = entityKey ? contentState.getEntity(entityKey) : null;
//     return entity ? entity.getData() : {};
// }
const styles = {
    root: {
        fontFamily: '\'Helvetica\', sans-serif',
        padding: 20,
        // width: 600,
        width: "100%",
    },
    editor: {
        border: '1px solid #ccc',
        cursor: 'text',
        minHeight: 200,
        padding: 10,
        fontSize: 'large'
    },
    button: {
        marginBottom: 10,
        textAlign: 'center',
    },
    immutable: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        padding: '2px 0',
    },
    mutable: {
        backgroundColor: 'rgba(204, 204, 255, 1.0)',
        padding: '2px 0'
    },
    segmented: {
        backgroundColor: 'rgba(248, 222, 126, 1.0)',
        padding: '2px 0',
    },
};


export {
    compositeDecorator,
    insertFun, myKeyBindingFn, getValue, getHtml, getContentStateToRowForJson, refreshByContentStateToRowJson,
    styles
};


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Component/common.js